<template>
  <div>
    <Header />
    <hero-section />
    <infos-profit-section />
    <partner-info />
    <infos-specificity-section />
    <infos-process-section />
    <calculator-section :content="calculator" />
    <simulation-section :content="simulation" />
    <scenario-section :content="scenarios">
      <button-open-dialog />
    </scenario-section>
    <questions-section />
    <agreements-dialog v-if="isVisible" />
    <Footer />
    <button-scroll-up />
  </div>
</template>

<script>

import Header from './components/Header'
import InfosProcessSection from '../../partner-components/infos/InfosProcessSection'
import InfosSpecificitySection from '../../partner-components/infos/InfosSpecificitySection'
import PartnerInfo from './components/PartnerInfo'
import InfosProfitSection from '../../partner-components/infos/InfosProfitSection'
import ButtonScrollUp from '../../partner-components/common/ButtonScrollUp'
import AgreementsDialog from '../../partner-components/agreements/AgreementsDialog'
import ScenarioSection from '../../partner-components/scenarios/ScenarioSection'
import SimulationSection from '../../partner-components/simulation/SimulationSection'
import CalculatorSection from '../../partner-components/calculator/CalculatorSection'
import QuestionsSection from '../../partner-components/questions/QuestionsSection'
import ButtonOpenDialog from '../../partner-components/common/ButtonOpenDialog'
import HeroSection from '../../partner-components/hero/HeroSection'
import Footer from '../../partner-components/Footer'

import ContentMixin from '../../mixins/content.mixin'

export default {
  name: 'DefaultLayout',
  components: {
    Header,
    PartnerInfo,
    InfosProcessSection,
    InfosSpecificitySection,
    InfosProfitSection,
    ButtonScrollUp,
    AgreementsDialog,
    ScenarioSection,
    SimulationSection,
    CalculatorSection,
    QuestionsSection,
    ButtonOpenDialog,
    HeroSection,
    Footer
  },
  mixins: [ContentMixin]
}
</script>

<style src="../../assets/partner-scss/style.scss" lang="scss"></style>
